// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".news-list img{width:180px;height:auto}.tclass tr td{border-top:0}.tclass tr:last-child .item{border-bottom:0}.tclass td,.tclass th{padding:0!important}", ""]);
// Exports
module.exports = exports;
